<template>
			<ob-modal2 :width="800" :show.sync="openModal">
				<template slot="modal-title">
					FDNS Visit Report
                    <!-- <a class="gotoprofile-txt" href="javascript:;" @click="goToProfilePage" v-if="ViewDataDetails && isHRManager">Go to profile page</a> -->
				</template>
				<template slot="modal-body">
                    <template v-if="ViewDataDetails == null">
                        <ob-spinner ></ob-spinner>
                    </template>
                    <template v-else>
                        <div id="printdocument1">
                            <div class="row print-adjustment-row">
                                <div class="col-md-3 ">
                                    <div class="form-group m0">
                                        <label>Full Name</label>
                                        <p  class="name-txt">{{ViewDataDetails && ViewDataDetails.Employee && ViewDataDetails.Employee.ConsultantName ? ViewDataDetails.Employee.ConsultantName : 'N/A'}}</p>
                                        
                                    </div>
                                </div>
                                <div class="col-md-3 ">
                                    <div class="form-group m0">
                                        <label>Email Address</label>
                                        <p  class="name-txt">{{ViewDataDetails && ViewDataDetails.Employee && ViewDataDetails.Employee.EmailAddress ?  ViewDataDetails.Employee.EmailAddress : 'N/A'}}</p>
                                       
                                    </div>
                                </div>
                                <div class="col-md-3 ">
                                    <div class="form-group m0">
                                        <label>Designation</label>
                                        <p class="name-txt">{{ViewDataDetails && ViewDataDetails.Employee && ViewDataDetails.Employee.Designation ? ViewDataDetails.Employee.Designation : 'N/A'}}</p>
                                        
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group m0">
                                        <label>Tax Terms</label>
                                        <p  class="name-txt">{{ViewDataDetails && ViewDataDetails.Employee && ViewDataDetails.Employee.TaxTerms ? ViewDataDetails.Employee.TaxTerms : 'N/A'}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="row print-adjustment-row margin-second">
                                <div class="col-md-3 ">
                                    <div class="form-group m0">
                                        <label>Visit Date</label>
                                        <p  class="name-txt">{{ViewDataDetails && ViewDataDetails.VisitOfficerDate ? ViewDataDetails.VisitOfficerDate : 'N/A'}}</p>
                                    
                                    </div>
                                </div>
                                <div class="col-md-3 ">
                                    <div class="form-group m0">
                                        <label>Visit Officer Name</label>
                                        <p  class="name-txt">{{ViewDataDetails && ViewDataDetails.VisitOfficerName ?  ViewDataDetails.VisitOfficerName : 'N/A'}}</p>
                                
                                    </div>
                                </div>
                                <div class="col-md-3 ">
                                    <div class="form-group m0">
                                        <label>Visit Officer Email</label>
                                        <p class="name-txt">{{ViewDataDetails && ViewDataDetails.VisitOfficerEmail ? ViewDataDetails.VisitOfficerEmail : 'N/A'}}</p>
                                         
                                    </div>
                                </div>
                                <div class="col-md-3 ">
                                    <div class="form-group m0">
                                        <label>Visit Location</label>
                                        <p class="name-txt">{{ViewDataDetails && ViewDataDetails.VisitOfficerLocation ? ViewDataDetails.VisitOfficerLocation : 'N/A'}}</p>
                                         
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="row">
                                <list :showCategoryDropDown="false" :QuestionCategoryList="QuestionCategoryList" :QuestionList="QuestionList" OrgId="" :readOnly="true"></list>
                            </div>
                        </div>
                    </template>
				</template>
				<template slot="modal-footer" v-if="ViewDataDetails">
                    <ob-button type="secondary" @click="openModal=false">Close</ob-button>
                    <ob-button type="secondary" @click="onPrint">Print</ob-button>
                </template>
			</ob-modal2>
		</template>
<script>
    // import utils from '@/components/Core/utils.js'
    import c from '@/components/Core/constants.js'
    import List from "../QA/List.vue"
    export default{
    props:{
        openviewAuditProfilePopUp:{
                 type: Boolean,
                default: false
        },
        tosummaryReportId:{}
         },
        data(){
            return{
                openModal:'',
                ViewDataDetails: null,
                QuestionList: [],
                QuestionCategoryList: [],
            }
        },
        components: {
        "list": List
        },
        created(){
            this.openModal = this.openviewAuditProfilePopUp
        },
        watch:{
            openviewAuditProfilePopUp(val){
                this.openModal = val
            },
            openModal(val){
                this.$emit('update:openviewAuditProfilePopUp',val)
                if(val == true){
                    this.init()
                }
                if(val == true){
                    this.ViewDataDetails = null
                }
            }
        },
        methods:{
           onPrint() {
                var w = window.open();
                var printOne = document.getElementById('printdocument1').innerHTML
                w.document.write('<html><head><title>Summary</title><style>* { box-sizing: border-box; } .col-md-12 { float: left; width: 100%; } .col-md-6 { float: left; width: 50%; } .col-md-2 { float: left; width: 16.66666667%; } .col-md-3 { float: left; width: 25%; } .col-md-4 { float: left; width: 33.33333333%;} body { -webkit-print-color-adjust: exact; font-size: 13px; font-family: sans-serif;}.name-txt {color: #30303f;font-size: 13px;font-weight: 600;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;} .print-adjustment-row {padding: 15px;} .margin-second {margin-top: 20px;margin-bottom: 20px;}.head-section {padding: 0px 15px 10px 22px;border-bottom: 1px solid #4a90e3;top: -15px;background: #fff;z-index: 1;}.head-section h4 {color: #4a90e3;font-size: 15px;font-weight: 600;}.section-ans-con {padding: 20px 20px 0 20px;}.section-ans-con label {color: #666;font-size: 14px;font-weight: 600;}.section-ans-con p {padding-left: 17px;}.gotoprofile-txt {color: #337ab7;float: right;font-size: 12px;text-decoration: underline;}.fixed-dropdown {position: fixed;right: 23px;top: 215px;z-index: 2;}.fdnsaudit-container {background: #fff;}.heading-txt {padding: 15px 15px 5px 22px;border-bottom: 1px solid #4a90e3;background: #fff;z-index: 1;}.heading-txt p {color: #4a90e3;font-size: 14px;font-weight: 600;}.fdnsaudit-data {margin: 15px 30px 15px 0;}.fdnsaudit-data label {color: #666;font-size: 13px;font-weight: 600;margin: 0;}.fdnsaudit-data .ob-vuelidate_error-msg {color: #d60000;margin-left: 15px;margin-top: -8px;display: block;}.edit-ans {text-decoration: underline;color: #4a90e2;  font-style: italic;font-weight: 600;vertical-align: middle;}.hide-ans {text-decoration: underline;color: #d60000;font-size: 12px;font-style: italic;font-weight: 600;vertical-align: middle;}.edit-row {margin-left: 15px;}.edit-row .update-date {display: inline;}.edit-row .edit-hide-data {float: right;}.edit-row .edit-hide-data .hide-answer {float: left;margin-right: 15px;}.edit-row .edit-hide-data .edit-answer {float: right;}.answer-txt {display: block;margin: 10px 0;width: 100%;margin-left: 15px;}.manual-txt {display: inline;color: #b3b2bb;font-size: 12px;font-weight: 600;vertical-align: middle;}.Fdns-audit-fluid {padding: 0px 20px 0 20px;}.fdnsaudit-container {background: #fff;}.fdns-footer {padding: 0 0 20px 0;text-align: center;}.fdns-header_tabs {margin: 20px 0 0 0;}.fdns-header_tabs ul {padding: 0;width: 60%;display: inline-block;}.fdns-header_tabs ul li {list-style: none;display: inline;padding: 7px 0px 7px 20px;}.fdns-header_tabs ul li a {font-size: 16px;font-weight: 600;color: #b0b2b5;}.fdns-header_tabs ul li.active {border-bottom: 3px solid #2d4972;}.fdns-header_tabs ul li.active a {color: #143361;}.MT-Content {margin-top: 8%;text-align: center;width: 100%;height: 100%;vertical-align: middle;display: block;font-weight: 600;}.heading-txt {padding: 15px 15px 5px 22px;border-bottom: 1px solid #4a90e3;background: #fff;z-index: 1;}.heading-txt p {color: #4a90e3;font-size: 14px;font-weight: 600;}.fixed-dropdown {position: fixed;right: 15px;top: 191px;z-index: 2;}.fdns-dadalabel label span {font-size: 13px;}.fdns-dadalabel p {padding-left: 15px;font-size: 13px;}.clearfix{clear: both;}</style></head><body><h1 style="margin: 0; padding: 15px; font-size: 20px;">Summary</h1>' + printOne + '</body></html>');
                w.window.print();
                w.document.close();
            },
            goToProfilePage() {
                if(this.ViewDataDetails) {
                let sd = this.ViewDataDetails
                let workpermit = sd.Employee.TaxTerms.split('W2-')[1]
                let url = `${c.APPLICATIONBASEURL}/app/profile/${sd.Employee.ConsultantId}/onblick/projectsinfo?tax=W2&workpermit=${workpermit}&jobId=${this.tosummaryReportId.JobId}&noprogress=true&nocallchat=true`
                window.open(url, '_blank')
                }
            },
            init(){
                var ajaxUrl
                  if(this.isHRManager){
                       ajaxUrl = `/FDNSAudit/GetFDNSReportDetails?reportId=${this.tosummaryReportId.ReportIdSummary}&empOrgId=''`
                  }
                  else{
                       ajaxUrl = `/FDNSAudit/GetFDNSReportDetails?reportId=${this.tosummaryReportId.ReportIdSummary}&empOrgId=${this.tosummaryReportId.empId}`

                  }
                ajax.get(ajaxUrl,{},(res) =>{
                    if(res.data.State == true){
                        this.ViewDataDetails = res.data.FdnsModel

                        let arr = res.data.FdnsModel.FDNSQuestions;

                        let questionList = [];

                        let tempArr = [];

                        let tempCat = [];

                        if (arr.length > 0) {
                        arr = __.sortBy(arr, [
                            function(o) {
                            return o.QuestionCategory.Name;
                            }
                        ]);

                        let category = arr[0].QuestionCategory.Name;
                        tempCat.push(category);

                        for (var i = 0; i < arr.length; i++) {
                            if (arr[i].QuestionCategory.Name == category) {
                            tempArr.push(arr[i]);
                            } else {
                            questionList.push(tempArr);
                            tempArr = [];
                            category = arr[i].QuestionCategory.Name;
                            tempCat.push(category);
                            tempArr.push(arr[i]);
                            }
                        }

                        if (tempArr.length > 0) {
                            questionList.push(tempArr);
                        }

                        if (tempCat[tempCat.length - 1] != category) {
                            tempCat.push(category);
                        }
                        }
                        this.QuestionCategoryList = tempCat;
                        this.QuestionList = questionList;

                        let obj = {}
                        obj.FdnsModel = res.data.FdnsModel
                        obj.QuestionList = res.data.FdnsModel.FDNSQuestions

                        this.$store.commit('updateFDNSSelectedReportDetails', obj)
                     }
				else {
                    this.ESSEnableDisable(res)
                    this.$message({
                        type: 'error',
                        message: res.data.Message
                    })
                }

                })
            }
        }
    }
</script>
<style scoped lang="scss">
.name-txt{
	color: #30303f;
    font-size: 13px;
    font-weight: 600;
	white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
	}
    .margin-second{
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .head-section{
        padding: 0px 15px 10px 22px;
        border-bottom: 1px solid #4a90e3;
        top: -15px;
        background: #fff;
        z-index: 1;
        h4 {
            color: #4a90e3;
            font-size: 15px;
            font-weight: 600;
        }
    }
    .section-ans-con{
        padding: 20px 20px 0 20px;
            label{
                color: #666;
                font-size: 14px;
                font-weight: 600;
            }
            p{
                    padding-left: 17px;
            }
    }
    .gotoprofile-txt{
        color: #337ab7;
        float: right;
        font-size: 12px;
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/FDNS/FDNS-PopUp/ViewAuditReportPopup.vue